import { fad, far, fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { StringUtils } from './StringUtils';

export class IconUtils {
  static iconFromIconStr = (iconStr) => {
    if (!iconStr) return null;
    if (typeof iconStr !== 'string') {
      return iconStr;
    }

    let iconSet = fas;
    if (iconStr.includes(' ')) {
      const setStr = iconStr.split(' ')[0];
      if (setStr === 'far') {
        iconSet = far;
      } else if (setStr === 'fad') {
        iconSet = fad;
      }

      iconStr = iconStr.split(' ')[1];
    }

    return iconSet?.[StringUtils.toLowerCamel(iconStr)];
  };
}
